let PromptTip = xClass("PromptTip", function () {
    return cc.CSLoader.createNode("cocos/homeScene_number99.csb")
})
PromptTip.prototype.ctor = function () {
    let self = this
    self.num = self.getChildByName("txt")
    self.num.setAnchorPoint(0.5, 0.5)
    self.num.setPosition(0, -4)
    self.num.setScale(1.3)
    self.num.setFontSize(19);
    self.num.setFontWeight("bold")
}
PromptTip.prototype.getNum = function () {
    return tonumber(this.num.getString())
}
PromptTip.prototype.setNum = function (num) {
    if (num <= 0) {
        this.setVisible(false)
    }else {
        this.setVisible(true)
        this.num.setString(num)
    }
}
module.exports = PromptTip